import { instance } from '@/services/avik-api-gateway'
import { DeviationDisruptionReason } from '@/types/deviation-disruption-reason'
import { AxiosResponse } from 'axios'

export function createDeviationDisruptionReason(
  body: DeviationDisruptionReason
): Promise<AxiosResponse<DeviationDisruptionReason>> {
  return instance.post(`/deviation-disruption-activity`, body)
}
